<app-three-column-template
  [showBreadcrumbAlways]="true"
  [titleSize]="E_TITLE_SIZES.md"
  [showLoader]="showLoader()"
  pageTitle="Manage topics"
  [hasCustomMain]="true">

  <div class="simple-breadcrumbs" slot="breadcrumb-section">
    <a [routerLink]="['/',HELPER.frLoc, 'my-topics' ]">
      <div class="item primary">My topics</div>
    </a>
    <i class="icon-CaretRight"></i>
    <div class="item">Manage topics</div>
  </div>

  <div class="main-wrapper">
    <div class="desc">
      Follow topics that matter to you for a personalized experience. Check the box next to a topic to add it to My
      Topics on the website, receive weekly email summaries, and get updates in the mobile app.
    </div>

    <div class="settings">
      <div class="title-wrapper">
        <div class="item">
          <div class="title">Topics</div>
          <div class="website">
            Website<br>
            <mat-checkbox
              [indeterminate]="websiteIndeterminate()"
              (change)="toggleAllTopics($event, E_MANAGE_FIELDS.website)"
              [checked]="websiteChecked()"/>
          </div>
          <div class="email">
            Email<br>
            <mat-checkbox
              [indeterminate]="emailIndeterminate()"
              (change)="toggleAllTopics($event, E_MANAGE_FIELDS.email)"
              [checked]="emailChecked()"/>
          </div>
        </div>
      </div>
      <div class="settings-wrapper">
        @for (item of topicSettings(); track item.topicId) {
          <div class="item">
            <div class="title"><i class="icon-BookBookmark"></i>{{ item.name }}</div>
            <div class="website">
              <mat-checkbox
                (change)="toggleTopicItem(item, $event, E_MANAGE_FIELDS.website)"
                [checked]="item.website"/>
            </div>
            <div class="email">
              <mat-checkbox
                (change)="toggleTopicItem(item, $event, E_MANAGE_FIELDS.email)"
                [checked]="item.email"/>
            </div>
          </div>
        }
      </div>
    </div>


    <div class="title">
      Publications newsletter
    </div>
    <div class="desc">
      Manage your subscriptions to weekly email updates featuring publications that match your interests. Each email
      includes summaries and links to the latest content.
    </div>

    <div class="settings">
      <div class="title-wrapper">
        <div class="item">
          <div class="title">Publication series</div>
          <div class="email"> Email<br>
            <mat-checkbox
              [indeterminate]="emailFolderIndeterminate()"
              (change)="toggleAllFolder($event)"
              [checked]="emailFolderChecked()"/>
          </div>
        </div>
      </div>
      <div class="settings-wrapper">
        @for (item of folderSettings(); track item.email) {
          <div class="item">
            <div class="title"><i class="icon-FolderSimple"></i>{{ item.title }}</div>
            <div class="email">
              <mat-checkbox
                (change)="toggleFolderItem(item, $event)"
                [checked]="item.email"/>
            </div>
          </div>
        }
      </div>
    </div>

    <div class="actions">
      <app-button
        (clicked)="saveMySettings()"
        [buttonStyleType]="BUTTON_TYPES.PRIMARY_0"
        [buttonSize]="BUTTON_SIZE.FULL_SIZE">Save changes
      </app-button>
      <app-button
        (clicked)="getMySettings()"
        [buttonStyleType]="BUTTON_TYPES.SECONDARY_0"
        [buttonSize]="BUTTON_SIZE.FULL_SIZE">Cancel
      </app-button>
    </div>

  </div>


</app-three-column-template>
